import { render } from "./editContact.vue?vue&type=template&id=ac45fa84"
import script from "./editContact.vue?vue&type=script&lang=js"
export * from "./editContact.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__